import React from "react";
import Layout from "../components/App/Layout";
import SEO from "../components/App/SEO";
import MainBanner from "../components/Home/MainBanner";
import OurProducts from "../components/Home/OurProducts";
import IntroOfHr from "../components/Home/IntroOfHr";
import IntroOfHro from "../components/Home/IntroOfHro";
import OurFeatures from "../components/Home/OurFeatures";
import Appraise from "../components/Home/appraise";
import Service from "../components/Home/service";
import News from "../components/Home/News";

const Home = () => {
  return (
    <Layout stickyHeader>
      <SEO
        title="大任HR软件-领先的ehr人力资源管理软件，打造高效人事系统"
        ogTitle="人力外包系统_劳务派遣软件_绩效考核系统_人力资源管理系统_人力资源软件_快速开发平台-成都市大任软件有限责任公司"
        keywords="人事系统，hr系统，hr人力管理系统，hr软件，ehr人力资源管理软件，人力资源管理系统"
        description="大任HR软件专注于为企业提供先进的hr人力管理系统，致力于通过信息化手段提升人力资源效能，重塑HR价值。HR系统涵盖人才招聘、人事档案管理、绩效管理工具、考勤排班模块等，助您实现人力资源管理的智能化、高效化，助力企业快速发展。"
      />

      <MainBanner />

      <OurProducts />
      <IntroOfHr />
      <IntroOfHro />
      <OurFeatures />
      <Appraise />
      <Service />
      <News />
    </Layout>
  );
};

export default Home;
